import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [savedCount] = useState(3);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Properties', to: '/listings' },
    { label: 'Buy', to: '/listings?type=sale' },
    { label: 'Rent', to: '/listings?type=rent' },
    { label: 'Dashboard', to: '/dashboard' },
    { label: 'Contact', to: '/contact' },
  ];

  const isTransparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-white/95 backdrop-blur-md shadow-sm border-b border-stone-100'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-18 flex items-center justify-between" style={{ height: '72px' }}>
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/2c33ea10-b2d8-439b-9a97-77605099d973.png"
            alt="MyAbode Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isTransparent
                  ? 'text-white/90 hover:text-white'
                  : 'text-stone-600 hover:text-stone-900'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Right Actions */}
        <div className="hidden md:flex items-center gap-3">
          <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${isTransparent ? 'text-white hover:bg-white/10' : 'text-stone-500 hover:bg-stone-100'}`}>
            <i className="ri-search-line text-lg"></i>
          </button>
          <Link to="/dashboard" className={`relative w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${isTransparent ? 'text-white hover:bg-white/10' : 'text-stone-500 hover:bg-stone-100'}`}>
            <i className="ri-heart-line text-lg"></i>
            {savedCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-amber-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                {savedCount}
              </span>
            )}
          </Link>
          <Link
            to="/listings"
            className="ml-1 px-5 py-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            List Property
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer ${isTransparent ? 'text-white' : 'text-stone-700'}`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-4 py-4 flex flex-col gap-3">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className="text-stone-700 font-medium py-2 border-b border-stone-50 cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/listings"
            onClick={() => setMobileOpen(false)}
            className="mt-2 px-5 py-2.5 bg-amber-500 text-white text-sm font-semibold rounded-full text-center cursor-pointer"
          >
            List Property
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
